import {FileUploaderDropContainer, FileUploaderItem} from "@carbon/react";
import {useEffect, useState} from "react";
import {addFile, removeFile} from "../../../utils/fileUtils.js";

const Index = ({item = {}, types, output, inModal = false}) => {
    const [fileState, setFileState] = useState({...item, ...{filename: '', file: ''}})
    const [submitState, setSubmitState] = useState(false)
    useEffect(() => {
        removeFile(setFileState)
    }, [item])
    useEffect(() => {
        if (fileState.file !== '' && fileState.filename !== '' && inModal) {
            output(fileState)
        }
    }, [fileState])
    useEffect(() => {
        if (!submitState) {
            removeFile(setFileState)
        }
    }, [submitState])
    return (
        <div className='file-uploader-container'>
            <div className={'file-uploader-area'}>
                <FileUploaderDropContainer
                    disabled={submitState}
                    accept={types}
                    labelText="Para subir el archivo, arrastre y suelte o haga click aquí"
                    name=""
                    multiple={false}
                    onAddFiles={(e, files) => addFile(e, files.addedFiles, setFileState, types)}
                >

                </FileUploaderDropContainer>
                <div
                    className="cds--file-container"
                >
                    {fileState.filename !== '' &&
                        <FileUploaderItem name={fileState.filename}
                                          onDelete={() => !submitState ? removeFile(setFileState) : false}
                                          status={'edit'}></FileUploaderItem>
                    }
                </div>

            </div>
        </div>
    )
}

export default Index
